import { Dateline } from "@/components/ui/dateline";
import { criticalityLabel as vocabCriticalityLabel } from "@/components/experience/vocabulary";
import type { Outline } from "./scenario-detail-types";

interface ScenarioHeaderProps {
  outline: Outline;
  personaCount: number;
}

export function ScenarioHeader({ outline, personaCount }: ScenarioHeaderProps) {
  const items: Array<{ label: string; value: React.ReactNode }> = [];

  if (outline.taskCriticality) {
    items.push({
      label: "Criticality",
      value: vocabCriticalityLabel(outline.taskCriticality),
    });
  }

  items.push({
    label: "Personas",
    value: `${personaCount} cast`,
  });

  return (
    <div className="space-y-3">
      {outline.description && (
        <p className="max-w-[72ch] text-base text-muted-foreground">
          {outline.description}
        </p>
      )}
      <Dateline items={items} />
    </div>
  );
}
